import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

const styles = {
  iconInputLogin: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2
  },

  iconInputLoginEye: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    cursor: 'pointer'
  },

  margin: {
    height: 50
  },

  cardTitleWhite: {
    fontSize: '31px',
    color: "#1989FF",
    textAlign: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px'
  },
};

const useStyles = makeStyles(styles);

export default function NotFound() {
  const classes = useStyles();
  let history = useHistory();

  return (
    <div className={classes.gridContainer}>
      <GridContainer style={{ position: 'fixed', justifyContent: 'center', textAlign: 'center', height: '100%', alignItems: 'center', zIndex: 1 }} >
        <GridItem>
          <Card style={{
            backgroundColor: '#f8f9fd',
            borderRadius: 25,
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            borderColor: '#C8C8C8',
            height: '380px',
            width: '380px',
            boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
          }}>
            <CardHeader style={{ height: '30px', marginTop: 20, marginBottom: 10 }}>
              <h4 className={classes.cardTitleWhite} style={{
                lineHeight: '20px',
                fontWeight: 400,
                color: '#1989ff',
                fontSize: 28
              }}>Error 404 Not Found</h4>
            </CardHeader>

            <CardBody style={{ marginTop: 40 }}>
              <i className='icon-smiley-devastated' style={{ width: 28, fontSize: 80, color: '#8e8e8e' }}></i>
              <h4 className={classes.cardTitleWhite} style={{
                lineHeight: '30px',
                fontWeight: 100,
                color: '#464646',
                fontSize: 18,
                marginTop: 10
              }}>Desculpe!<br/>A página que você acessou não existe!</h4>
            </CardBody>

            <CardFooter style={{ justifyContent: 'center', alignItems: 'baseline', height: '100px', display: 'grid', padding: 0, marginTop: 20 }}>
              <Button style={{ borderRadius: '25px', width: 180 }} onClick={() => history.push("/")} color="primary">Voltar</Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
